import VueUeditorWrap from 'vue-ueditor-wrap'
import BaseStore from '../../../components/BaseStore'

export default {
  extends: BaseStore,
  components: {VueUeditorWrap},
  data () {
    return {
      query: {
        date: this.getDate()
      },
      htmlContent: '',
      oHtmlContent: '',
      rawData: null
    }
  },
  computed: {
    apiKey: () => null,
    editorConfig: () => ({
      // 设置编辑器不自动被内容撑高
      autoHeightEnabled: false,
      // 初始容器宽度
      initialFrameWidth: '100%',
      // 初始容器高度
      // initialFrameHeight: '100%',
      focus: true,
      initialStyle: 'body{height:auto!important;margin:0!important;padding:2.54cm 1.52cm 2.54cm 1.27cm!important;}p{line-height:1.5;;text-align:justify;}',
      toolbars: [[
        // 'fullscreen',
        // 'source',
        // '|',
        'undo',
        'redo',
        '|',
        'bold',
        'italic',
        'underline',
        'fontborder',
        'strikethrough',
        'superscript',
        'subscript',
        'removeformat',
        'formatmatch',
        'blockquote',
        '|',
        'forecolor',
        'backcolor',
        'insertorderedlist',
        'insertunorderedlist',
        '|',
        'rowspacingtop',
        'rowspacingbottom',
        'lineheight',
        '|',
        'customstyle',
        'paragraph',
        'fontfamily',
        'fontsize',
        '|',
        'indent',
        '|',
        'justifyleft',
        'justifycenter',
        'justifyright',
        'justifyjustify',
        '|',
        'touppercase',
        'tolowercase',
        '|',
        'pagebreak',
        '|',
        'horizontal',
        'spechars',
        'wordimage',
        '|',
        'inserttable',
        'deletetable',
        'insertparagraphbeforetable',
        'insertrow',
        'deleterow',
        'insertcol',
        'deletecol',
        'mergecells',
        'mergeright',
        'mergedown',
        'splittocells',
        'splittorows',
        'splittocols',
        'charts',
        '|',
        'imagenone',
        'imageleft',
        'imageright',
        'imagecenter',
        '|',
        'help'
      ]],
      fontsize: [10, 11, 12, 14, 16, 18, 20, 24, 26, 28, 30, 32, 34, 36, 48, 72],
      elementPathEnabled: false,
      wordCount: false,
      // 可以放后台存放路径
      serverUrl: '',
      // UEditor 是文件的存放路径，
      UEDITOR_HOME_URL: '/static/Ueditor/'
    }),
    hasReport () {
      return !!this.oHtmlContent
    }
  },
  methods: {
    getDate () {
      return new Date().format('YYYY/MM/DD')
    },
    getFormatHtmlContent (htmlContent) {
      return (htmlContent || '').replace(/(line-height:\s*\d*(\.\d+)?)em/ig, (match, replacement) => replacement)
    },
    setResponseResult (htmlContent, isLoadData) {
      this.oHtmlContent = htmlContent = this.getFormatHtmlContent(htmlContent)
      this.htmlContent = htmlContent.replace(/src="image\//g, `src="/report/${this.query.date}/image/`)

      if (this.hasReport && isLoadData !== false) {
        setTimeout(() => {
          this.changeLoadStatus(true)
          this.$api.WordReport[`get${this.apiKey}Detail`](this.query).then(data => {
            this.rawData = Object.freeze(data)
          }).catch(console.error).finally(() => {
            this.changeLoadStatus(false)
          })
        }, 0)
      } else {
        this.rawData = null
      }
    },
    setErrorResult (error) {
      console.error(error)
      this.setResponseResult(null)
    },
    createReport () {
      this.changeLoadStatus(true)
      this.$api.WordReport[`create${this.apiKey}`](this.query)
        .then(({html, data}) => {
          this.setResponseResult(html, false)
          this.rawData = Object.freeze(data)
        }).catch(this.setErrorResult).finally(() => {
          this.changeLoadStatus(false)
        })
    },
    onDateChange () {
      this.changeLoadStatus(true)
      this.$api.WordReport[`get${this.apiKey}`](this.query)
        .then(this.setResponseResult)
        .catch(this.setErrorResult).finally(() => {
          this.changeLoadStatus(false)
        })
    },
    onCreateReportBtnClick () {
      (this.hasReport
        ? this.$confirm(`重新生成报告将覆盖现有报告, 是否继续？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirm-dialog-confirm-btn',
          cancelButtonClass: 'confirm-dialog-cancel-btn',
          type: 'warning'
        }) : new Promise(resolve => resolve())
      ).then(this.createReport).catch(() => {})
    },
    isCreated () {
      if (!this.hasReport) {
        this.$alert('请先生成报表', '提示', {
          confirmButtonText: '确定'
        })

        return false
      }

      return true
    },
    getHtmlContent () {
      const htmlContent = this.getFormatHtmlContent(this.htmlContent).replaceAll(`src="/report/${this.query.date}/image/`, `src="image/`)
      return [htmlContent, htmlContent !== this.oHtmlContent]
    },
    saveReport (htmlContent, callbacks) {
      this.changeLoadStatus(true)
      let promise = this.$api.WordReport[`save${this.apiKey}`](this.query, htmlContent).then(() => new Promise(resolve => {
        this.oHtmlContent = htmlContent
        resolve()
      }))

      callbacks.forEach(callback => {
        promise = promise.then(callback)
      })

      promise.catch(console.error).finally(() => {
        htmlContent = null
        this.changeLoadStatus(false)
      })
    },
    onSaveReportBtnClick () {
      if (this.isCreated()) {
        const htmlContent = this.getHtmlContent()

        if (htmlContent[1]) {
          this.saveReport(htmlContent[0], [() => {
            this.$notify({
              title: '提示',
              message: '保存成功',
              type: 'success',
              position: 'bottom-right'
            })
          }])
        }
      }
    },
    exportReport () {
      return this.$api.WordReport[`export${this.apiKey}`](this.query)
    },
    downloadReport (reportPath) {
      if (reportPath) {
        const link = document.createElement('a')
        let count = 0
        const list = ['年', '月', '日']
        link.download = reportPath.replaceAll('/', function () {
          return list[count++]
        })
        link.href = `/report/${reportPath}`
        link.click()
      }
    },
    onExportReportBtnClick () {
      if (this.isCreated()) {
        const htmlContent = this.getHtmlContent()

        if (htmlContent[1]) {
          this.saveReport(htmlContent[0], [this.exportReport, this.downloadReport])
        } else {
          this.changeLoadStatus(true)
          this.exportReport().then(this.downloadReport).catch(console.error).finally(() => {
            this.changeLoadStatus(false)
          })
        }
      }
    }
  },
  created () {
    this.onDateChange()
  }
}



// WEBPACK FOOTER //
// ./src/views/06Data-Management/03Report/BaseWordEditor.js